<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="containerBig">
    <!--<v-layout justify-end>
      <v-flex md3>
        <v-btn @click="restart" color="#004884" dark small outline block round
               class="font-weight-bold radiusBtn text-none">
          {{ 'BUTT_SEARCH_BANK' | translate}}
        </v-btn>
      </v-flex>
    </v-layout>-->
    <v-layout row wrap class="pa-0">
      <v-flex x12 class="pa-0">
        <!-- Stand 29.03.2019 -->
        <v-tabs v-model="tabModel"
                color="blue"
                dark
                slider-color="#8ACAC1"
                @change="onChangeTab"
                class="activetab"
        >
          <v-tab class="text-none">
            {{ 'TAB_NEWSBOX_CHANGE' | translate }}
          </v-tab>
          <v-tab class="text-none">
            {{ 'TAB_NEWSBOX_FAV' | translate }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabModel">
          <v-tab-item>
            <NewsboxChanges></NewsboxChanges>
          </v-tab-item>
          <v-tab-item>
            <NewsboxFavourites></NewsboxFavourites>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import NewsboxChanges from "./NewsboxChanges";
import NewsboxFavourites from "./NewsboxFavourites";
var _ = require('lodash')

export default {
  name: 'changelog',
  components: {NewsboxFavourites, NewsboxChanges},
  watch: {
    selected: function (value) {
      Vue.prototype.$api.debug('selected', value)
      this.selected = value
    }
  },
  data () {
    return {
      cellspan: 6,
      ankerBank: null,
      tabModel: 0,
      hasAnkerBank: false,
      emailSet: [
        {text: Vue.i18n.translate('EMAIL_JA'), id: '1'},
        {text: Vue.i18n.translate('EMAIL_NEIN'), id: '0'}
      ],
      // Name, CrefoNr./HGP-Nr., Region, Land, E-Mail-Benachrichtigung (an/aus)
      crefoDoubleExists: false,
      pagination: {
        rowsPerPage: 5000,
        descending: true,
        sortBy: 'year'
      },
      tableData: [],
      tableDataBL: [],
      countries: [],
      selected: []
    }
  },
  methods: {
    onChangeTab (item) {
      Vue.prototype.$api.debug('onChangeTab', item, this.lastTab)
      if (this.lastTab) {
        if (this.$refs[item] && this.$refs[item].close) {
          this.$refs[item].close()
        }
      }
      if (this.$refs[item] && this.$refs[item].open) {
        this.$refs[item].open(this.data)
      }

      this.lastTab = item

    },
    restart () {
      // window.location = '/rating/displayApplicationsOrApplicationAreas.php?AppNr=161'
      window.location = Vue.prototype.storage.appConfig.RESET_URL
    },

    showGroup (item) {
      if (item.diffText !== null) {
        return true
      }
      return false
    },
    toggleAll () {
      if (this.selected.length) {
        for (var index in this.selected) {
          var item = this.selected[index]
          this.setEmailNotification(item, false)
        }
        this.selected = []
      } else {
        this.selected = this.tableDataBL.slice()
        for (var index1 in this.selected) {
          var item1 = this.selected[index1]
          this.setEmailNotification(item1, true)
        }
      }
    },
    parseDate: function (dateStr) {
      var d = moment(dateStr)
      return d
    },
    saveEmailNotification: function (item) {
      Vue.prototype.$api.debug('saveEmailNotification', item)
      if (!item.isEmail) {
        item.email = '1'
        this.setEmailNotification(item, true)
      } else {
        item.email = '0'
        this.setEmailNotification(item, false)
      }
    },
    setEmailNotification: function (item, isEmail) {
      Vue.prototype.$api.debug('setEmailNotification', item, isEmail)
      if (isEmail) {
        item.email = '1'
      } else {
        item.email = '0'
      }
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.updateChangeLogs(item, this.onGetUpdate, this.onGetUpdate)
    },
    onGetUpdate (data) {
      Vue.prototype.$api.debug('onGetUpdate')
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    changeSort (column) {
      Vue.prototype.$api.debug('change sort', column)
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    dayDiff (date1, date2) {
      let dayDifference = date1.diff(date2, 'days')
      return dayDifference
    },
    onGetBankData (item) {
      Vue.prototype.$api.debug('onGetBankData', item, this.currentItem)
      Vue.prototype.$api.hideIdle()
      var param = {
        year: '' + this.currentItem.Jahr,
        crefoNr: this.currentItem.CrefoNr,
        bankBalanceDate: item.bilanzDate,
        balanceDate: item.bilanzDate,
        rechtskreis: this.currentItem.RechtskreisNr,
        abschlussart: this.currentItem.AbschlussartNr,
        guid: item.bankID,
        isForwardItem: true,
        hasAnkerbank: false,
        bankCurrency: item.bankCurrency + '',
        currency: item.bankCurrency + '',
        currencyDim: item.bankCurrencyDim + '',
        country: this.currentItem.country,
        region: this.currentItem.region,
        balanceSum: item.bankBalanceSums,
        orderNr: item.orderNr,
        sourceNr: item.sourceNr,
        ultimateMother: item.ultimateMother,
        lastChanged: item.lastChanged,
        name: this.currentItem.name,
        branch: this.currentItem.BranchenkategorieNr
      }
      item.isAnkerbank = true
      Vue.prototype.storage.ankerBank = param
      this.$router.push({name: 'AnkerbankDetails', params: param})
    },
    onSetNotificationDone () {
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    deleteItem (item) {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.setAlertFunction(this, item.CrefoNr, false, this.onSetNotificationDone, this.onSetNotificationDone)
    },
    getDocArray (item, _header) {
      var result = []
      var value = item[_header.value]
      if (_header.value === 'docTypes') {
        result = value.split(',')
        if (!result) {
          result = []
        }
      }
      return result
    },
    downloadDocument (row, item, index) {
      item = item.trim()
      var url = this.getUrlPDF(row.auftragNr, item)
      window.open(url, '_new')
    },
    getPDFTitle (row, item, index) {
      Vue.prototype.$api.debug('getPDFTitle', row, item, index)
      item = item.trim()
      return Vue.i18n.translate('CHANGE_LOG_DOWNLOAD_DOC_TITLE_'+item)
    },
    downloadDocumentWithTypExists (docType, row) {
      var value = row['docTypes']
      var result = []
      if (value) {
        result = value.split(',')
        if (!result) {
          result = []
        }
      }
      var found = false
      _.forEach(result, function (head) {
        if (docType === head) {
          found = true
        }
      })
      return found
    },
    openItem (item) {
      item['bank'] = item.id
      item['type'] = 'JSON'
      item['year'] = item.Jahr
      Vue.prototype.$api.debug('item', item)
      if (item.Aenderungsgrund === '3') {
        return
      }
      this.currentItem = item
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getBankDataByTriple(item, this.onGetBankData, Vue.prototype.$api.onFailure)
    },
    getValue (item, _header) {
      var value = item[_header.value]
      if (_header.value === 'RechtskreisNr') {
        var e = Vue.prototype.$api.getI18NRechtsKreis(item.RechtskreisNr)
        if (e) value = e.title
      }
      if (_header.value === 'Aenderungsgrund') {
        e = Vue.prototype.$api.getI18NAenderungsgrund(item.Aenderungsgrund)
        if (e) value = e.title
      }
      if (_header.value === 'QuelleNr') {
        e = Vue.prototype.$api.getI18NQuelle(item.QuelleNr)
        if (e) value = e.lanValue
      }
      if (_header.value === 'branch') {
        e = Vue.prototype.$api.getI18NBranche(item.branch)
        if (e) value = e.title
      }
      if (_header.value === 'country') {
        e = Vue.prototype.$api.getI18NCountry(item.country)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'region') {
        e = Vue.prototype.$api.getI18NRegion(item.region)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'datumZeit') {
        if (value) {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }

      if (_header.value === 'docTypes') {
        var types = value.split(',')
        var html = ''
        for (var index in types) {
          var items = types[index]
          // html = html + '<img style="margin-right:10px;padding-top:4px; height:20px;" src="static/pdf.png"/>'
          // html = html + '<span class="tableDownloadPDF handpointer" key="index" documentIndex="index" text="item.DokumententypNr + item.year+ item.label" title="item.DokumententypNr + item.year+ item.label"> <v-icon>get_app</v-icon></span>'
        }
        return html
        //
      }
      if (_header.value === 'AbschlussartNr') {
        e = Vue.prototype.$api.getI18NAbschlussart(item.AbschlussartNr)
        if (e) value = e.title
      }
      if (_header.value === 'balanceSum') {
        if (!Number.isFinite(value)) {
          var maximumFractionDigits = 2
          var minimumFractionDigits = 2
          value = (1 * value).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        }
      }
      if (item.isAnkerBank) {
        var v = value
        if (!v) v = ''
        return '<b>' + v + '</b>'
      }
      return value
    },
    getHeaderClass (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    getUrlPDF (orderId, type) {
      var urlPDF = Vue.prototype.storage.host() + '/ajaxGetBankOrderAsPDF.php?type=' + type + '&orderId=' + orderId
      urlPDF = urlPDF
      Vue.prototype.$api.debug('this.config.urlPDF', urlPDF)
      return urlPDF
    },
    getClassFor (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    onChangeLogs: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getChangeLogs(this.onGetChangelogs, this.onGetChangelogs)
      Vue.prototype.$api.getChangeLogBL(this.onGetChangelogBL, this.onGetChangelogs)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/changelog/Changelog.vue